import { IMarca } from '../interface/IMarca';

export class Marca implements IMarca {

  id: number;
  nombre: string;
  imagen: string;
  esDestacada: boolean;
  orden: number;
  totalProductos?: number;
  fecCreacion?: Date;
  fecModificacion?: Date;
  modificado?: boolean;
  nuevaImagen?: any;

  constructor(marca: IMarca) {
    this.id = marca.id;
    this.nombre = marca.nombre;
    this.imagen = marca.imagen;
    this.esDestacada = marca.esDestacada;
    this.orden = marca.orden;
    this.totalProductos = marca.totalProductos;
    this.fecCreacion = marca.fecCreacion;
    this.fecModificacion = marca.fecModificacion;
    this.nuevaImagen = marca.nuevaImagen;
  }

  getFormData(): FormData {
    const formData = new FormData();
    if (this.nombre) {
      formData.append('nombre', this.nombre);
    }
    if (this.esDestacada) {
      formData.append('esDestacada', '1');
    } else {
      formData.append('esDestacada', '0');
    }
    if (this.orden) {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }
    if (typeof this.nuevaImagen !== 'undefined') {
      formData.append('file_upload', this.nuevaImagen, this.nuevaImagen.name);
    }

    return formData;
  }

  getFormDataOrden(): FormData {
    const formData = new FormData();
    if (typeof this.orden !== 'undefined') {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }

    if (this.esDestacada) {
      formData.append('esDestacada', '1');
    } else {
      formData.append('esDestacada', '0');
    }
    return formData;
  }

}



// WEBPACK FOOTER //
// /app/src/model/class/Marca.ts